import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=08d036d2&scoped=true&"
import script from "./SubHeader.vue?vue&type=script&lang=js&"
export * from "./SubHeader.vue?vue&type=script&lang=js&"
import style0 from "./SubHeader.vue?vue&type=style&index=0&id=08d036d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d036d2",
  null
  
)

component.options.__file = "SubHeader.vue"
export default component.exports